module.exports = __webpack_public_path__ + "83e6d26105bbcdcccebb89a96867e716.fbx";